var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoamingYouthDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.663 6.122c-.146.134-.634.588-.764.723l-2.728 2.63c-.03.028-.072.043-.108.028l-9.858-2.52a.924.924 0 0 0-.87.21l-1.02.933c-.241.22-.105.54.183.688l7.713 4.253a.116.116 0 0 1 .027.188l-5.2 4.901a.464.464 0 0 1-.405.125l-3.344-.505a.913.913 0 0 0-.78.23l-.723.663a.236.236 0 0 0 .042.38l3.53 2.212c.212.107.38.294.463.52l1.816 3.779a.23.23 0 0 0 .37.081l.718-.658a.957.957 0 0 0 .306-.762l-.155-3.478a.484.484 0 0 1 .164-.395l5.346-4.677c.064-.05.153-.03.182.047l3.402 8.205c.116.306.416.475.657.254l1.02-.933a.944.944 0 0 0 .294-.855l-1.47-10.186a.116.116 0 0 1 .038-.107l2.86-2.482c.15-.122.641-.562.788-.696 1.907-1.746 2.557-3.472 1.868-4.244-.688-.772-2.45-.3-4.362 1.448z",
    fill: "#EBDEF5",
    fillOpacity: 0.2,
    stroke: "url(#unfba3wcda)",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "unfba3wcda",
    x1: 0.105,
    y1: 16.155,
    x2: 25.377,
    y2: 16.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB52B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B066E8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoamingYouthDark);
export default __webpack_public_path__ + "static/media/Roaming_Youth_Dark.aea5978af667f780215d5e1940ec6019.svg";
export { ForwardRef as ReactComponent };